import { ColorScales } from '@styles/color-scales';

export type ChoroplethMapColors = typeof CHOROPLETH_MAP_COLORS;
export const CHOROPLETH_MAP_COLORS = [
  [0, ColorScales.blue[1]],
  [0.2, ColorScales.blue[3]],
  [0.4, ColorScales.blue[4]],
  [0.6, ColorScales.blue[5]],
  [0.8, ColorScales.blue[7]],
  [1, ColorScales.blue[9]],
] as const;

export const PIECHART_COLORS = {
  green: [
    ColorScales.green[9],
    ColorScales.green[8],
    ColorScales.green[7],
    ColorScales.green[6],
    ColorScales.green[4],
    ColorScales.green[2], // Other
  ],
  blue: [
    ColorScales.blue[9],
    ColorScales.blue[7],
    ColorScales.blue[5],
    ColorScales.blue[4],
    ColorScales.blue[3],
    ColorScales.blue[1], // Other
  ],
  purple: [
    ColorScales.purple[9],
    ColorScales.purple[7],
    ColorScales.purple[5],
    ColorScales.purple[4],
    ColorScales.purple[3],
    ColorScales.purple[2], // Other
  ],
  orange: [
    ColorScales.orange[9],
    ColorScales.orange[8],
    ColorScales.orange[7],
    ColorScales.orange[6],
    ColorScales.orange[5],
    ColorScales.orange[2], // Other
  ],
};

export const LINECHART_COLORS = [
  ColorScales.cyan[5],
  ColorScales.orange[5],
  ColorScales.teal[5],
  ColorScales.purple[5],
];
